<script type='text/jsx'>
import _ from 'lodash';
import { toThousands } from '@/utils/money';
import { planTypes, isEventSaasOrEventSassCore } from '@/common/constants';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ConfigTextRow from '@/plans/EVENT_SAAS/component/config-text-row.vue';
import { capitalizeFirstLetter } from '@/common/utils';

export default {
  name: 'config-consumption-row-v2',
  components: { ConfigTextRow },
  props: {
    selectCapacitySize: {
      type: String,
      default: 'large',
    },
    capacityKey: {
      type: String,
      default: 'capacity',
    },
    planType: {
      type: String,
      default: planTypes.EVENT_SAAS,
    },
  },
  data() {
    return {
      trackingPlanKey: '',
    };
  },
  computed: {
    ...mapGetters(['getTypeGroupSelectedPlans', 'planMapFlat']),
    capacityList() {
      const consumptionPlanList = _.filter(this.planMapFlat, (p) => p.type === this.planType && p.isPPA);

      return _.chain(consumptionPlanList)
        .uniq(this.capacityKey)
        .orderBy(this.capacityKey)
        .value();
    },
    selectedPlanList() {
      return _.filter(this.getTypeGroupSelectedPlans[this.planType], (p) => p.isPPA);
    },
    selectedPlan() {
      return _.get(this.selectedPlanList, [0], {});
    },
    selectCapacity() {
      return this.selectedPlan?.capacity;
    },
  },
  methods: {
    ...mapMutations(['batchRemovePlan', 'updateSelectPlan']),
    ...mapActions(['switchCapacityAction']),
    mx_renderTitle() {
      return <h2 class='opc-consumption-config__title'>Select number
        of {isEventSaasOrEventSassCore(this.planType) ? 'attendees' : 'participants'}</h2>;
    },
    mx_renderCapacityDropDown() {
      const groupOptions = [
        {
          label: this.$t('billing.billing_cycle.pay_per_attendee'),
          options: this.capacityList,
        },
      ];
      return <div class='opc-consumption-config__capacity--dropdown'>
        <zm-select
          data-testid="checkout-select-48"
          ref='attendeeSelect'
          inline-label={capitalizeFirstLetter(this.$t('billing.attendees'))}
          popperAppendToBody={true}
          size={this.selectCapacitySize}
          value={this.selectCapacity}
          label='zoom sessions Select number of attendees'
          onInput={this.onSwitchCapacity}
          popper-class='opc-capacity-config-row__capacity--popper'
          class='opc-consumption-config__capacity--select'>
          {
            groupOptions.map(group => {
              return <zm-option-group
                key={group.label}
                label={group.label}>
                {
                  group.options.map((p) => {
                    return <zm-option
                      data-testid="checkout-option-49"
                      key={p.capacity}
                      value={p.capacity}
                      label={toThousands(p.capacity)}
                    />;
                  })
                }
              </zm-option-group>;
            })
          }
        </zm-select>
      </div>;
    },
    mx_renderCapacityDesc() {
      return <div class='opc-consumption-config__capacity--desc'>
        <span class='opc-consumption-config__capacity--desc-price'>{this.$money(this.selectedPlan?.amount, {forceDiff:true})}</span>
        <span
          class='opc-consumption-config__capacity--desc-unit'>
          ({this.selectCapacity} {isEventSaasOrEventSassCore(this.planType) ? this.$t('billing.common.per_billing_cycle_attendee.annual') : this.$t('billing.common.per_billing_cycle_attendee.annual').replace('attendees', 'participants')}<priceVATTip />)
        </span>
        <zm-tooltip
          class='opc-consumption-config__capacity--tooltips'
          aria-label='Learn more about Select the number of capacity'
          content={this.$t('billing.events.ppa.attendeeTips')}
          placement='bottom'
          onInput={this.toggleCapacityTips}>
          <i class='zm-icon-info-outline' />
        </zm-tooltip>
      </div>;
    },
    mx_renderCycleRow() {
      return <config-text-row title={this.$t('billing.plan')} value={this.$t('billing.billing_cycle.pay_per_attendee')} />;
    },
    mx_renderCapacityRow() {
      return <div class='opc-consumption-config__capacity--row'>
        <div class='opc-consumption-config__capacity--row__plan'>
          {this.mx_renderCapacityDropDown()}
          {this.mx_renderCycleRow()}
        </div>
        {this.mx_renderCapacityDesc()}
      </div>;
    },
    onSwitchCapacity(capacity) {
      const nextPlan = _.find(this.capacityList, (p) => p.capacity === capacity);
      this.switchCapacityAction([this.selectedPlan?.plan_code, { ...nextPlan, cartInfo: { selected_number: 1 } }]);
      if (this.$context.is.zs2ze) {
        this.$tracking.buyInteraction(`zoom events pay per attendee attendees`, `pay per attendee - ${capacity} attendees/year`);
      }
    },
    toggleCapacityTips(tips) {
      if (this.$context?.is.zs2ze) {
        tips && this.$tracking.buyInteraction(`zoom events options`, 'select number of attendees - tooltip');
      }
    },
    addDefaultPlan() {
      const plan = _.get(this.capacityList, [0], {});

      this.updateSelectPlan({
        plan_code: plan.plan_code,
        cartInfo: { selected_number: 1 },
      });
    },
    removePlans() {
      return this.batchRemovePlan(this.selectedPlanList);
    },
  },
  render() {
    return <div class='opc-consumption-config opc-consumption-config__v2'>
      {this.mx_renderTitle()}
      {this.mx_renderCapacityRow()}
    </div>;
  },
};
</script>

<style lang='scss'>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import './config-consumption-row.scss';

.opc-consumption-config.opc-consumption-config__v2 {
  .opc-consumption-config__capacity--dropdown {
    .zm-select .zm-select-input.zm-select--show-label {
      padding-top: 20px;
    }

    .zm-select .zm-select-input.is-focused .zm-select__label {
      line-height: 16px;
    }

    .zm-select.zm-select--xLarge .zm-select--show-label .zm-select-span__inner,
    .zm-select.zm-select--xLarge .zm-select--show-label .zm-select-input__inner {
      line-height: 24px;
      font-size: 18px;
    }
  }

  .opc-consumption-config__capacity {
    &--row {
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      &__plan {
        display: flex;

        @include media(mobile) {
          flex-direction: column;
        }
      }
    }

    &--select {
      width: 140px;
      height: 48px;

      @include media(mobile) {
        width: 200px;
      }
    }

    &--desc {
      margin-top: 16px;
    }
  }
}
</style>
